export interface AdminUserRequestModel {
  name: string;
  email: string;
  password?: string;
  email2FAEnabled?: boolean;
  email2FAAddress?: string;
}
